import React from "react";
import './styles.css'
import { useSelector } from "react-redux";
import BannerForm from "./BannerForm";

const AddBanner = () => {
    const banner = useSelector((state) => state.banner)

    if (banner.loading) {
        return "Loading"
    }

    if (banner.error) {
        return "Loading"
    }
    return (
        <div>
            <p className="create_banner_header">Create Banner</p>
            <p className="banner_sub_header">Carefully Create New Banner</p>
            <div className="banner_form banner_stage banner_dot">
                <div className="cs-form" >
                    <BannerForm banner={banner} action='Create' />
                </div>
            </div>
        </div>)
}

export default AddBanner